<template>
    <div class="home-sales-other-section" v-if="indexPage != null">
        <div class="container">
            <div class="section-title">
                <h2>{{ indexPage.other_sales_title }}</h2>
            </div>
            <div class="other-sales-cards">
                <div class="card" v-for="item in indexPage.other_sales_items">
                    <router-link :to="item.link">
                        <div class="card-pic" :style="!isMobileChecker ? 'background-image: url(' + item.img + ')' : 'background-image: url(' + item.img_mobile + ')'"></div>
                        <div class="card-info">
                            <h3>{{ item.name }}</h3>
                            <p v-html="item.desc"></p>
                            <div class="btn-go btn-wow-effect-hover">
                                <svgIcon name="arrow-right" class="icon-right-arrow"/>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'home-sales-other-section',
        components: {
            svgIcon,
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
            }
        },
        computed: mapGetters({
            indexPage: 'loadIndexPage',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/home-page/home-sales-other.scss';
    @import '@/styles/components/home-page/respond/home-sales-other-respond.scss';
    // @import '@/styles/components/home-page/respond/home-sales-respond.scss';
    // @import '@/styles/components/home-page/respond/home-actions-respond.scss';
    // @import '@/styles/components/home-page/respond/home-promo-respond.scss';
</style>